import "core-js/modules/es6.function.name.js";
/* eslint-disable no-param-reassign */
import produce from 'immer';
var genomeCreated = produce(function (draft, action) {
  var _action$payload = action.payload,
    id = _action$payload.id,
    name = _action$payload.name,
    description = _action$payload.description;
  draft.custom[id] = {
    id: id,
    name: name,
    description: description,
    files: {},
    built: false,
    createdAt: new Date().toISOString()
  };
});
export default genomeCreated;